import styled from '@emotion/styled'

export const StyleNavItem = styled.ul`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 10px;
  @media (max-width: 768px) {
    display: none;
  }
`
